import {
  Button,
  Col, Icon, Row, Select,
  Tooltip
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'


import {
  fetchSinglePropertyEnquiryFxn,
  getPropertyEnquiryListFxn
} from '../action'
import {
  DefaultTablePagination,
  displayDate, longDisplayDate
} from '../../../components/_utils/appUtils'
import { getUrlPushWrapper } from '../../../routes/routes'
import { CountryCodeJson as countryCodes } from '../../../components/_utils/countryUtil'
import _ from 'lodash'
import { enquiryStatus, getStatusLabel } from '../../../components/_utils/utils'
import EnquiryStatusUpdateDrawer from '../drawer/enquiryStatusUpdateDrawer'
import AddEnquiryModal from '../modal/addEnquiryModal'
import EditEnquiryModal from '../modal/editEnquiryModal'
import AddNote from '../drawer/addNote'

let initFilter = {
  fullName: '',
  id: '',
  email: '',
  phoneNumber: '',

  propertyId: '',
  propertyName: '',
  countryName: '',
  cityName: '',
  status: ''
}

const { Option } = Select

const RenderNote = (props) => {
  let { item } = props
  let [hideV, setHideV] = useState(true)
  return (
    item && (
      <div>
        {item.addedBy && item.addedBy.name ? (
          <div className={'alignRight colorPrimary font12'}>
            (Added By : {item.addedBy.name} )
          </div>
        ) : null}
        <div>{longDisplayDate(item.date)}</div>

        <div className={hideV ? 'appCommentDotsReplace' : ''}>
          {item && item.note ? item.note : ''}
        </div>
        {item && item.note.length && item.note.length > 50 ? (
          <div className={'alignRight'}>
            {hideV ? (
              <a
                onClick={() => {
                  setHideV(false)
                }}>
                Show More
              </a>
            ) : (
              <a
                onClick={() => {
                  setHideV(true)
                }}>
                Show Less
              </a>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  )
}

const EnquiryManagementList = () => {
  const [total, setTotal] = useState(0)
  const [filterState, setFilterState] = useState(initFilter)
  const [filters, setFilters] = useState(initFilter)
  const [singlePropertyData, setSinglePropertyData] = useState('')
  const [allCountries, setAllCountries] = useState([])
  const tableRef = useRef()
  const dispatch = useDispatch()
  const [enquiryStatusUpdate, setEnquiryStatusUpdate] = useState({
    visible: false,
    enquiryId: '',
    selectedValue: ''

  })
  const [addEnquiry, setAddEnquiry] = useState({
    visible: false


  })
  const [addNote, setAddNote] = useState({
    visible: false,
    enquiryId: ''

  })
  const [editEnquiry, setEditEnquiry] = useState({
    visible: false,
    enquiryId: ''

  })
  const getSingleEnquiry = async (id) => {
    let data = await dispatch(fetchSinglePropertyEnquiryFxn({ _id: id }))
    setSinglePropertyData(data.property)

  }


  const apiRequest = params => {
    return new Promise(async resolve => {
      let resp = events.getParamsForInventoryList()
      params = { ...params, ...resp }
      if (filters.fullName) params.fullName = filters.fullName.trim()
      if (filters.email) params.email = filters.email.trim()
      if (filters.phoneNumber) params.phoneNumber = filters.phoneNumber.trim()
      if (filters.status) params.status = filters.status.trim()
      if (filters.propertyName) {
        params.propertyName = { $regex: filters.propertyName.trim(), $options: 'i' }
      }
      if (filters.countryName) params.countryName = { $regex: filterState.countryName, $options: 'i' }
      if (filters.cityName) {
        params.cityName = { $regex: filterState.cityName, $options: 'i' }
      }


      params.results = 50
      params.count = 50
      let respData = await dispatch(
        getPropertyEnquiryListFxn({
          ...params,
          regExFilters: ['fullName', 'email', 'phoneNumber', 'dialCode', 'status', 'propertyId', 'propertyName', 'cityName', 'countryName']
        })
      )
      getStatusLabel()
      setTotal(respData.total)
      resolve(respData)
    })
  }

  const loadCountry = () => {
    let designatedArr = []
    _.each(countryCodes, (item) => {
      designatedArr.push({
        name: `${item.code} - ${item.name}`,
        value: item.name
      })
    })
    setAllCountries(designatedArr)
  }

  useEffect(() => {
    loadCountry()
  }, [])

  const events = {
    openEnquiryStatusDrawer: async (id, status) => {
      setEnquiryStatusUpdate({
        visible: true,
        enquiryId: id,
        selectedValue: status
      })

    },
    hideEnquiryStatusDrawer: async () => {

      setEnquiryStatusUpdate({
        visible: false,
        enquiryId: '',
        selectedValue: ''
      })
    },
    openAddEnquiry: async (id, status) => {
      setAddEnquiry({
        visible: true
      })

    },
    hideAddEnquiry: async () => {

      setAddEnquiry({
        visible: false

      })
    },
    openAddNote: async (id) => {
      setAddNote({
        visible: true,
        enquiryId: id
      })
      // getLatestNote(id)
    },
    hideAddNote: async () => {
      setAddNote({
        visible: false,
        enquiryId: ''
      })
      if (tableRef.current) {
        tableRef.current.reload()
      }
    },
    openEditEnquiry: async (id) => {
      setEditEnquiry({
        visible: true,
        enquiryId: id
      })
      getSingleEnquiry(id)

    },
    hideEditEnquiry: async () => {
      setEditEnquiry({
        visible: false,
        enquiryId: ''

      })
    },
    updateFilterState: (data) => {
      setFilterState({
        ...filterState,
        ...data
      })
    },
    getParams: (field) => {
      const searchParams = new URLSearchParams(window.location.search)

      return searchParams.get(field) || ''
    },
    setFieldByParams: () => {
      let obj = {}
      for (let key in initFilter) {

        if (initFilter.hasOwnProperty(key) && events.getParams(key)) {
          obj[key] = events.getParams(key)
        }
      }

      setFilterState((prevState) => ({
        ...prevState,
        ...obj
      }))
      setTimeout(() => {
        if (tableRef.current) {
          tableRef.current.reload()
        }
      }, 0)
    },
    getParamsForInventoryList: () => {
      let { fullName, email, phoneNumber, status, propertyName, countryName, cityName } = filterState
      let obj = {}

      if (fullName) obj.fullName = fullName
      if (email) obj.email = email
      if (status) obj.status = status
      if (phoneNumber) obj.phoneNumber = phoneNumber
      if (propertyName) obj.propertyName = propertyName
      if (countryName) obj.countryName = countryName
      if (cityName) obj.cityName = cityName
      return obj
    },
    searchFxns: async () => {
      let obj = {}

      if (filterState.fullName) obj.fullName = filterState.fullName
      if (filterState.email) obj.email = filterState.email
      if (filterState.phoneNumber) obj.phoneNumber = filterState.phoneNumber
      if (filterState.city) obj.city = filterState.city
      if (filterState.country) obj.country = filterState.country
      if (filterState.name) obj.name = filterState.name
      if (filterState.propertyName) obj.propertyName = filterState.propertyName
      if (filterState.countryName) obj.countryName = filterState.countryName
      if (filterState.cityName) obj.cityName = filterState.cityName
      dispatch(
        getUrlPushWrapper('enquiryManagementList', {
          ...obj
        })
      )
      tableRef.current.reload()

    },
    clearFxn: async () => {
      let obj = {}
      setFilterState({
        fullName: '',
        email: '',
        phoneNumber: '',
        name: '',
        city: '',
        cityName: '',
        propertyName: '',
        countryName: '',
        status: ''
      })

      dispatch(
        getUrlPushWrapper('EnquiryManagementList', {
          ...obj
        })
      )

      setTimeout(() => {
        if (tableRef && tableRef.current) {
          tableRef.current.reload()
        }
      }, 200)

    }

  }
  useEffect(() => {
    events.setFieldByParams()
  }, [])


  const reload = () => {
    if (tableRef && tableRef.current) {
      tableRef.current.reload()
    }
  }

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (val, record, index) => {
        return index + 1
      }
    },

    {
      title: 'Full Name',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 150
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 150
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      width: 150,
      render: (text, record) => {
        return `${record.dialCode} ${record.phoneNumber}`
      }
    },
    {
      title: 'Property Name',
      dataIndex: 'propertyName',
      key: 'propertyName',
      width: 150,
      render: (item) => {
        return item
      }
    },

    {
      title: 'Country',
      dataIndex: 'countryName',
      key: 'countryName',
      width: 150,
      render: (item) => {
        return item
      }
    },
    {
      title: 'City',
      dataIndex: 'cityName',
      key: 'cityName',
      width: 150,
      render: (item) => {
        return item
      }
    },
    {
      title: 'Agent',
      dataIndex: 'agent',
      key: 'agent',
      width: 150,
      render: (item) => {
        return (
          item ? <>
            {item.companyName ? item.companyName : null}
            {item.name ? ` (${item.name})` : null}
          </> : null
        )
      }
    },
    {
      title: 'Latest Note',
      key: 'latestNote',
      width: 250,
      render: (noteObj) => {
        return noteObj && noteObj.note ? <RenderNote item={noteObj} /> : null
      }
    },
    {
      title: 'Details',
      dataIndex: 'details',
      key: 'details',
      width: 200,
      render: (val, record) => {
        let { duration, budget, moveInDate, commission } = record
        return (
          <React.Fragment>
            <ul>
              <li>Budget : {budget || '__'}</li>
              <li>Move in Date : {moveInDate ? displayDate(moveInDate) : '__'}</li>
              <li>Duration : {duration || '__'}</li>
              <li>Commission : {commission || '__'}</li>
            </ul>
          </React.Fragment>
        )
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: (val, record) => {
        const statusClass = getStatusLabel(record.status || 'pending')
        return (
          <React.Fragment>
            <a className={`label ${statusClass} roundNew sm textCap`}>
              {record.status || 'pending'}
            </a>
          </React.Fragment>
        )
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: 150,
      fixed: 'right',
      render: (val, record) => {
        const status = record.status || 'pending'
        return (
          <React.Fragment>
            {status === 'pending' && (
              <Tooltip title='Update Status'>
                <a className={'btn btn-default roundNew xs'}
                   onClick={() => {
                     events.openEnquiryStatusDrawer(record._id, record.status)
                   }}>
                  Update Status
                </a>
              </Tooltip>
            )}
            <br />

            <Tooltip title='Edit Enquiry'>
              <a className={'btn btn-default roundNew xs'}
                 onClick={() => {
                   events.openEditEnquiry(record._id)
                 }}>
                Edit Enquiry
              </a>
            </Tooltip>
            <br />
            <Tooltip title='Add Note'>
              <a className={'btn btn-default roundNew xs'}
                 onClick={() => {
                   events.openAddNote(record._id)
                 }}>
                Add Note
              </a>
            </Tooltip>
          </React.Fragment>
        )
      }
    }
  ]
  const filterBlock = (
    <div className={'filter_box mt5'}>
      <Row gutter={16} className={'flexWrap'}>


        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='search-box-table round ml0'>
            <input
              className='form-control form-control'
              type='search'
              placeholder='Full Name'
              value={filterState.fullName}
              onChange={e => {
                events.updateFilterState({ fullName: e.target.value })
              }}
            />
            <img src='/dist/img/search.png' alt='' />
          </div>
        </Col>


        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='search-box-table round ml0'>
            <input
              className='form-control form-control'
              type='search'
              placeholder='Email'
              value={filterState.email}

              onChange={e => {
                events.updateFilterState({ email: e.target.value })
              }}
            />
            <img src='/dist/img/search.png' alt='' />
          </div>
        </Col>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='search-box-table round ml0'>
            <input
              className='form-control form-control'
              type='search'
              placeholder='Phone Number'
              value={filterState.phoneNumber}

              onChange={e => {
                events.updateFilterState({ phoneNumber: e.target.value })
              }}

            />
            <img src='/dist/img/search.png' alt='' />
          </div>
        </Col>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>
            <Select
              name='select status'
              onChange={item => {
                events.updateFilterState({ status: item })
              }}
              value={filterState.status || 'select status'}
              placeholder='Select status'
              allowClear={true}
              showSearch={true}
            >
              {enquiryStatus.map((item, key) => {
                return (
                  <Option value={item.value} key={item.value}>
                    {item.label}
                  </Option>
                )
              })}
            </Select>

          </div>
        </Col>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='search-box-table round ml0'>
            <input
              className='form-control form-control'
              type='search'
              placeholder='Property Name'
              value={filterState.propertyName}
              onChange={e => {
                events.updateFilterState({ propertyName: e.target.value })
              }}

            />
            <img src='/dist/img/search.png' alt='' />
          </div>
        </Col>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>
            <Select
              name='countryName'
              onChange={item => {
                events.updateFilterState({ countryName: item })
              }}
              value={filterState.countryName || 'select country'}
              placeholder='Select Country'
              allowClear={true}
              showSearch={true}
            >

              {allCountries.map((item, key) => {
                return (
                  <Option value={item.value} key={item.value}>
                    {item.value}
                  </Option>
                )
              })}
            </Select>
          </div>
        </Col>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='search-box-table round ml0'>
            <input
              className='form-control form-control'
              type='search'
              placeholder='City'
              value={filterState.cityName}
              onChange={e => {
                events.updateFilterState({ cityName: e.target.value })
              }}

            />
            <img src='/dist/img/search.png' alt='' />
          </div>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col md={8} sm={8} xs={12} lg={8}>
          <Button onClick={() => events.searchFxns()} className={'roundBtn'}>
            Search
          </Button>
          <Button onClick={() => events.clearFxn()} className={'roundBtn'}>
            Clear
          </Button>


        </Col>
      </Row>
    </div>
  )
  return (
    <div className='row mt-4'>
      <div className='col-lg-12'>
        <div className='card'>
          <div className='table-head d-flex align-items-center all-student-search'>
            <h5>Enquiry Management List : ({total || 0})</h5>
            <div className='search-box-table round'>
            </div>
            <div className='sort-box-table mark-btn'>
              <a className={'btn btn-default roundNew'}
                 onClick={() => {
                   events.openAddEnquiry()
                 }}
              >Add Enquiry</a>
            </div>

          </div>
          <div className='card-body table-responsive'>
            {filterBlock}
            <TableComp
              columns={columns}
              apiRequest={apiRequest}
              ref={tableRef}
              pagination={DefaultTablePagination()}
              extraProps={{ scroll: { x: 1500 } }}
            />
          </div>

        </div>
      </div>
      {enquiryStatusUpdate.visible && (
        <EnquiryStatusUpdateDrawer
          {...enquiryStatusUpdate}
          refreshList={() => reload()}
          onClose={() => events.hideEnquiryStatusDrawer()}
        />
      )}
      {addEnquiry.visible && (
        <AddEnquiryModal
          {...addEnquiry}
          refreshList={() => reload()}
          onClose={() => events.hideAddEnquiry()}
        />
      )}
      {editEnquiry.visible && (
        <EditEnquiryModal
          {...editEnquiry}
          singlePropertyData={singlePropertyData}
          refreshList={() => reload()}
          onClose={() => events.hideEditEnquiry()}
        />
      )}
      {addNote.visible && (
        <AddNote
          {...addNote}
          refreshList={() => reload()}
          onClose={() => events.hideAddNote()}
        />
      )}
    </div>
  )
}

export default EnquiryManagementList
